import PropTypes from 'prop-types'

import {documentToReactComponents} from '@contentful/rich-text-react-renderer'

import {getContentfulDocumentPlainText} from './utils.js'

const DocumentContentful = ({content, rendererOptions = {}}) => {
  return <div className="mt-DocumentContentful">{documentToReactComponents(content, rendererOptions)}</div>
}

DocumentContentful.displayName = 'DocumentContentful'
DocumentContentful.propTypes = {
  content: PropTypes.array,
  rendererOptions: PropTypes.object
}

export default DocumentContentful
export {getContentfulDocumentPlainText}
